import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xaDMzMXZ4MCB7CiAgd2hpdGUtc3BhY2U6IG5vd3JhcDsKICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsKICBvdmVyZmxvdy14OiBoaWRkZW47Cn0';
export var truncateStyle = '_1h331vx0';